import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  logo_url: "/logo.jpg",
  brand_left: "Pharmaco",
  brand_right: "Hires",
  tagline: "Connecting Pharma Talent",
  contact_email: "careers@pharmacohires.com",
  contact_phone: "+91 99999 99999",
  offices: ["Hyderabad", "Mumbai", "Bengaluru"],
  hire_talent_button_text: "Hire Talent",
  upload_resume_button_text: "Upload Resume",
  footer_description: "",
  home_content: {},
  about_content: {},
  services_content: {},
  hire_talent_content: {},
  marquee_keywords: [],
  strategic_advantage: {},
  terms_content: "",
  privacy_content: "",
  social: {
    linkedin: "https://linkedin.com",
    twitter: "",
    facebook: "",
    instagram: "",
    youtube: "",
    whatsapp: "919999999999",
  },
  seo: {
    default_title: "PharmacoHires — Connecting Pharma Talent",
    default_description:
      "Specialised pharma recruitment agency connecting scientific talent with leading pharma, biotech and CRO organisations across India.",
    keywords: "",
    og_image: "",
    twitter_handle: "",
    google_site_verification: "",
    google_analytics_id: "",
  },
  stats_placements: 1240,
  stats_clients: 80,
  stats_industries: 12,
  stats_years_experience: 8,
};

const SettingsContext = createContext({ settings: DEFAULTS, loading: true, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const [sRes, pRes] = await Promise.all([
        api.get("/settings"),
        api.get("/page-seo").catch(() => ({ data: {} })),
      ]);
      const r = sRes.data;
      setSettings({
        ...DEFAULTS,
        ...r,
        social: { ...DEFAULTS.social, ...(r?.social || {}) },
        seo: { ...DEFAULTS.seo, ...(r?.seo || {}) },
        home_content: { ...(r?.home_content || {}) },
        about_content: { ...(r?.about_content || {}) },
        services_content: { ...(r?.services_content || {}) },
        hire_talent_content: { ...(r?.hire_talent_content || {}) },
        marquee_keywords: Array.isArray(r?.marquee_keywords) ? r.marquee_keywords : [],
        strategic_advantage: r?.strategic_advantage && typeof r.strategic_advantage === "object" ? r.strategic_advantage : {},
        terms_content: r?.terms_content || "",
        privacy_content: r?.privacy_content || "",
        page_seo: pRes.data || {},
      });
    } catch (e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const value = useMemo(() => ({ settings, loading, refresh }), [settings, loading]);
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSiteSettings() {
  return useContext(SettingsContext);
}

export { DEFAULTS as SITE_DEFAULTS };
